module.exports = __webpack_public_path__ + "static/scalar-6df73fc58fcbc7a1043925e47c4f6e6b.png";